import { UseFormReturn } from "react-hook-form";

export function getValues<T>(form: UseFormReturn<T>) {
  return form.getValues() as T;
}

export const ControlledInputClassNames = (errors: boolean, touched: boolean) =>
  `mt-1 w-full px-3 py-2 text-base border border-gray-300 focus:outline-none  sm:text-sm rounded-md ${
    errors
      ? "border-red-default focus:ring-red-default focus:border-red-default"
      : touched
      ? "border-green-default focus:ring-green-default focus:border-green-default"
      : "focus:ring-yellow-default focus:border-yellow-default"
  }`;
